(function () {
  // Counts down to the configured end date, or to the next local midnight when none is set.
  function parseEnd(value) {
    if (!value) return null;
    var match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);
    if (!match) return null;
    return new Date(+match[1], +match[2] - 1, +match[3], +(match[4] || 23), +(match[5] || 59), match[4] ? 0 : 59);
  }

  function nextMidnight() {
    var d = new Date();
    d.setHours(24, 0, 0, 0);
    return d;
  }

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function init(root) {
    var end = parseEnd(root.getAttribute('data-end'));
    var hours = root.querySelector('[data-hours]');
    var minutes = root.querySelector('[data-minutes]');
    var seconds = root.querySelector('[data-seconds]');

    function tick() {
      var target = end && end > new Date() ? end : end ? null : nextMidnight();
      var left = target ? Math.max(0, Math.floor((target - new Date()) / 1000)) : 0;
      hours.textContent = pad(Math.floor(left / 3600));
      minutes.textContent = pad(Math.floor((left % 3600) / 60));
      seconds.textContent = pad(left % 60);
    }

    tick();
    setInterval(tick, 1000);
  }

  function boot() {
    document.querySelectorAll('[data-custom-countdown]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
